exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3YUmEm8Rl1Y6z0688VhXo9{background-color:#448aff;padding:50px 0 25px;text-align:center}._2WAGbVf3kKVP0xHS_V2Nlz{text-align:center;color:#fff}._1bjR4pMoCA38M5_6ymP6DM{margin:5px;font-weight:700;text-transform:capitalize}.qEDZidDxo4_TxfWA88860{color:#aaa}", ""]);

// exports
exports.locals = {
	"root": "_1M-jfXnNJKR1I_rHeX4Cpj",
	"headerContainer": "_3YUmEm8Rl1Y6z0688VhXo9",
	"headerText": "_2WAGbVf3kKVP0xHS_V2Nlz",
	"subHeader": "_1bjR4pMoCA38M5_6ymP6DM",
	"unavailable": "qEDZidDxo4_TxfWA88860"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/viewercard.css
 ** module id = 1023
 ** module chunks = 0
 **/